import { takeEvery, select } from 'redux-saga/effects'

import { getActivitiesHistory, activityActions, sendYesterdayActivity } from '../actions'
import { getIdentityActivitiesHistoryPage, getIdentityActivitiesHistoryLimit } from '../selectors'

export function* progressChangeHandler() {
  const page = yield select(getIdentityActivitiesHistoryPage)
  const limit = yield select(getIdentityActivitiesHistoryLimit)
  yield getActivitiesHistory.call({ page, limit })
}

export default function* fetchHistoryOnProgressUpdates() {
  yield takeEvery(
    [
      activityActions.commit.success.toString(),
      activityActions.did.success.toString(),
      activityActions.didnot.success.toString(),
      activityActions.complete.success.toString(),
      sendYesterdayActivity.success.toString(),
    ],
    progressChangeHandler
  )
}
